module.exports = { 
  verifyOptions: {
    expiresIn: '12h',
  },
  externalScripts: [
    {
      // Prismic
      link: `//static.cdn.prismic.io/prismic.js?repo=${process.env.NEXT_PUBLIC_PRISMIC_PROJECT}&new=true`,
      before: `
        window.googleId = 'k_xlkfnTTumel8RlYPwdLA';
      `,
      after: `
        window.prismic.startExperiment('k_xlkfnTTumel8RlYPwdLA')
      `,
    },
    {
      // google tag manager
      link: '//www.googletagmanager.com/gtm.js?id=GTM-ND4HNWP',
      before: `
        (function(w,l){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});})(window,'dataLayer');
      `,
    },
    // {
    //   // google tag manager
    //   link: '//www.googletagmanager.com/gtm.js?id=GTM-N27KFPD',
    //   before: `
    //     (function(w,l){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});})(window,'dataLayer');
    //   `,
    // },
    {
      // linkedIn
      link: '//snap.licdn.com/li.lms-analytics/insight.min.js',
      before: ` 
        window._linkedin_partner_id = "213737";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
      `,
    },
  ],
};
